import type { PastaStatus } from './models';

export const PASTA_STATUS_ORDER: PastaStatus[] = [
  'NOVO',
  'COLETA_DADOS',
  'RECEBIMENTO_DOCS',
  'COLETA_DADOS_COMPLEMENTARES',
  'VALIDACAO_PASTA',
  'AJUSTE',
  'PRE_ANALISE_CREDITO',
  'APROVADO',
  'REPROVADO',
  'CONDICIONADO',
];

export const PASTA_STATUS_LABELS: Record<PastaStatus, string> = {
  NOVO: 'Novo',
  COLETA_DADOS: 'Coleta de dados',
  RECEBIMENTO_DOCS: 'Recebimento de documentos',
  COLETA_DADOS_COMPLEMENTARES: 'Dados complementares',
  VALIDACAO_PASTA: 'Validação da pasta',
  AJUSTE: 'Ajuste documental',
  PRE_ANALISE_CREDITO: 'Pré-análise de crédito',
  APROVADO: 'Aprovado',
  REPROVADO: 'Reprovado',
  CONDICIONADO: 'Aprovado com Condicional',
  desconhecido: 'Status desconhecido',
};

export const PASTA_STATUS_DESCRIPTIONS: Record<PastaStatus, string> = {
  NOVO: 'Cliente recém-capturado pelo WhatsApp',
  COLETA_DADOS: 'Dados básicos em coleta',
  RECEBIMENTO_DOCS: 'Documentos obrigatórios em recebimento',
  COLETA_DADOS_COMPLEMENTARES: 'Dados complementares em coleta',
  VALIDACAO_PASTA: 'Pasta em validação documental',
  AJUSTE: 'Correção ou complemento documental',
  PRE_ANALISE_CREDITO: 'Pasta encaminhada para pré-análise de crédito',
  APROVADO: 'Pasta aprovada',
  REPROVADO: 'Pasta reprovada',
  CONDICIONADO: 'Pasta aprovada com condicional',
  desconhecido: 'Status recebido da API sem mapeamento conhecido',
};

export const PASTA_STATUS_BADGE_CLASSES: Record<PastaStatus, string> = {
  NOVO: 'border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-500/40 dark:bg-slate-400/10 dark:text-slate-200',
  COLETA_DADOS: 'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-400/40 dark:bg-blue-400/10 dark:text-blue-200',
  RECEBIMENTO_DOCS: 'border-cyan-200 bg-cyan-50 text-cyan-800 dark:border-cyan-400/40 dark:bg-cyan-400/10 dark:text-cyan-200',
  COLETA_DADOS_COMPLEMENTARES: 'border-teal-200 bg-teal-50 text-teal-800 dark:border-teal-400/40 dark:bg-teal-400/10 dark:text-teal-200',
  VALIDACAO_PASTA: 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-400/40 dark:bg-amber-400/10 dark:text-amber-200',
  AJUSTE: 'border-orange-200 bg-orange-50 text-orange-800 dark:border-orange-400/40 dark:bg-orange-400/10 dark:text-orange-200',
  PRE_ANALISE_CREDITO: 'border-violet-200 bg-violet-50 text-violet-800 dark:border-violet-400/40 dark:bg-violet-400/10 dark:text-violet-200',
  APROVADO: 'border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-400/40 dark:bg-emerald-400/10 dark:text-emerald-200',
  REPROVADO: 'border-red-200 bg-red-50 text-red-800 dark:border-red-400/40 dark:bg-red-400/10 dark:text-red-200',
  CONDICIONADO: 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-400/40 dark:bg-amber-400/10 dark:text-amber-200',
  desconhecido: 'border-slate-300 bg-slate-50 text-slate-700 dark:border-slate-500/40 dark:bg-slate-400/10 dark:text-slate-200',
};

export function getPastaStatusLabel(status: PastaStatus): string {
  return PASTA_STATUS_LABELS[status];
}

export function getPastaStatusBadgeClass(status: PastaStatus): string {
  return PASTA_STATUS_BADGE_CLASSES[status];
}

const API_STATUS_TO_PASTA_STATUS: Record<string, PastaStatus> = {
  NOVO: 'NOVO',
  COLETA_DADOS: 'COLETA_DADOS',
  RECEBIMENTO_DOCS: 'RECEBIMENTO_DOCS',
  COLETA_DADOS_COMPLEMENTARES: 'COLETA_DADOS_COMPLEMENTARES',
  VALIDACAO_PASTA: 'VALIDACAO_PASTA',
  AJUSTE: 'AJUSTE',
  PRE_ANALISE_CREDITO: 'PRE_ANALISE_CREDITO',
  APROVADO: 'APROVADO',
  REPROVADO: 'REPROVADO',
  CONDICIONADO: 'CONDICIONADO',
};

const PASTA_STATUS_TO_API_STATUS: Record<PastaStatus, string | null> = {
  NOVO: 'NOVO',
  COLETA_DADOS: 'COLETA_DADOS',
  RECEBIMENTO_DOCS: 'RECEBIMENTO_DOCS',
  COLETA_DADOS_COMPLEMENTARES: 'COLETA_DADOS_COMPLEMENTARES',
  VALIDACAO_PASTA: 'VALIDACAO_PASTA',
  AJUSTE: 'AJUSTE',
  PRE_ANALISE_CREDITO: 'PRE_ANALISE_CREDITO',
  APROVADO: 'APROVADO',
  REPROVADO: 'REPROVADO',
  CONDICIONADO: 'CONDICIONADO',
  desconhecido: null,
};

export function apiStatusToPastaStatus(apiStatus: string | null | undefined): PastaStatus {
  if (!apiStatus) return 'desconhecido';
  return API_STATUS_TO_PASTA_STATUS[apiStatus.trim().toUpperCase()] ?? 'desconhecido';
}

export function pastaStatusToApiStatus(status: PastaStatus): string | null {
  return PASTA_STATUS_TO_API_STATUS[status];
}
